export const DEFAULT_CSV_OPTIONS = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    showTitle: true,
    title: 'Exported CSV',
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
    filename: 'Exported CSV',
};
//# sourceMappingURL=DEFAULT_CSV_OPTIONS.js.map